/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@vds/grids';
import styled from 'styled-components';
import { Line } from '@vds/lines';

import { Body } from '../../../../../common/Typography/index';
import '../cart.css';
import { isMobile, getFlowType, getLTEUpgrade } from '../../../../../common/Helpers/index';
import { getProductRefData } from '../../../../../../utils/plansReference';

const Spacing = styled.div`
  margin: ${({ margin }) => margin && margin.map((value) => `${value}px`).join(' ')};
`;

const DueToday = (props) => {
  let planInfo = '';

  const renderHTMLContent = (SDList, plansReferenceData, pageName) => {
    const isDisplayDevice = SDList && SDList.cartItemType === 'DEVICE' && !SDList.isHomePhone;
    if (!isDisplayDevice) {
      return <></>;
    }

    planInfo = getProductRefData(SDList.sorId, SDList.productId, plansReferenceData);
    let planName = SDList?.deviceDisplayName || '';
    let EUPDetails = {};
    let equipmentUpgradeTitle = '';
    let equipmentUpgradeValue = '';
    let mtnValue = '';
    if (getLTEUpgrade()) {
      EUPDetails = props.EUPDetails ? props.EUPDetails : null;
      equipmentUpgradeTitle = EUPDetails && EUPDetails.EquipmentUpgradeTitle ? EUPDetails.EquipmentUpgradeTitle : '';
      equipmentUpgradeValue = EUPDetails && EUPDetails.EquipmentUpgradeValue ? EUPDetails.EquipmentUpgradeValue : '';
      mtnValue = EUPDetails && EUPDetails.MTNValue ? EUPDetails.MTNValue : '';
    }
    if (SDList?.deviceDisplayName) {
      planName = SDList.deviceDisplayName;
    } else if (planInfo && planInfo.length > 0) {
      if (getFlowType() === 'LTE') {
        planName = planInfo[0].cart_Tdy_lte;
      } else if (planInfo && planInfo.length > 0) {
        planName = planInfo[0].cart_Tdy_5g;
      }
    }
    let installationType;
    if (SDList.depletionType) {
      if (SDList.depletionType === 'F' || SDList.depletionType === 'L') {
        installationType = 'Self Setup';
      } else {
        installationType = 'Professional Setup';
      }
    }
    const { deliverBy, shipBy } = props;
    let backOrderMessage = '';
    if (
      SDList &&
      SDList.cartItemType === 'DEVICE' &&
      SDList?.inventory?.isBackorder &&
      SDList?.inventory?.preBackDate &&
      SDList.installationType === 'Self SetUp'
    ) {
      if (SDList.isShipBy === 'true' || SDList.isShipBy === true) {
        backOrderMessage = shipBy;
      }
      if (SDList?.inventory?.isDeliverBy === 'true' || SDList?.inventory?.isDeliverBy === true) {
        backOrderMessage = deliverBy;
      }
    }

    return (
      <>
        <Row>
          <Col xs={12}>
            <Body size="small" color="#6F7171">
              <span className="fontWight400">Included</span>
            </Body>
            <div className="marginTop4">
              <Body size="large">
                <span className="fontWight400">{planName}</span>
              </Body>
            </div>

            {SDList.depletionType !== null && (
              <div>
                <Spacing margin={isMobile() ? [42, 0, 0, 0] : [20, 0, 20, 0]}>{!isMobile() && <Line type="secondary" surface="light" />}</Spacing>
                <Body size="small" color="#6F7171">
                  Setup
                </Body>
                <Body size="large" style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="fontWight400" style={{ display: 'inline-block' }}>
                    {installationType}
                  </div>
                </Body>
              </div>
            )}

            <div className={isMobile() ? 'fontSize_2 pad05' : 'fontSize_4 pad05'}>
              {SDList &&
                SDList.cartItemType === 'DEVICE' &&
                SDList?.inventory?.isBackorder &&
                SDList?.inventory?.preBackDate &&
                SDList.installationType === 'Self SetUp' &&
                `${backOrderMessage} ${SDList?.inventory?.preBackDate.split('/')[0]}/${SDList?.inventory?.preBackDate.split('/')[1]}`}
              {getFlowType() === 'LTE' && SDList.cartItemType === 'DEVICE' && !SDList.isHomePhone
                ? ''
                : SDList?.discountedPrice && SDList?.discountedPrice !== '0.0' && !SDList?.totalPriceWithDiscount && <div>Discount Applied</div>}
              {getLTEUpgrade() && equipmentUpgradeTitle !== '' && SDList.quantity && SDList.cartItemType === 'DEVICE' ? (
                <div>
                  <div>{equipmentUpgradeTitle}</div>
                  <div>
                    {equipmentUpgradeValue}
                    <span className="MTNValue fontWight400">{mtnValue}</span>
                  </div>
                </div>
              ) : (
                ''
              )}

              {((SDList.quantity && SDList.itemType !== 'DEVICE') || (SDList.quantity && SDList.isHomePhone)) &&
                !(
                  planInfo &&
                  planInfo.length > 0 &&
                  planInfo[0].cartEditBtn &&
                  pageName !== 'orderreview' &&
                  pageName !== 'revieworder' &&
                  pageName !== 'orderconfirm'
                ) && <div>Quantity: {SDList.quantity}</div>}
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const { cartDetails, plansReferenceData, pageName } = props;
  return <>{cartDetails?.deviceItem && renderHTMLContent(cartDetails?.deviceItem, plansReferenceData, pageName)}</>;
};

DueToday.propTypes = {
  cartDetails: PropTypes.object,
  EUPDetails: PropTypes.object,
  deliverBy: PropTypes.string,
  shipBy: PropTypes.string,
  plansReferenceData: PropTypes.object,
  pageName: PropTypes.string,
};

export default DueToday;
